'use client';

import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';
import { SLIDES } from './PresentationShell';

const SECTIONS = [
{ key: 'intro', label: 'Giới thiệu', color: 'text-[#4caf7d]' },
{ key: 'journey', label: 'Hành trình', color: 'text-[#e8a030]' },
{ key: 'student', label: 'Sinh viên', color: 'text-[#4caf7d]' },
{ key: 'school', label: 'Nhà trường', color: 'text-[#a8d87a]' },
{ key: 'partnership', label: 'Hợp tác', color: 'text-[#e8a030]' },
{ key: 'ambassador', label: 'Ambassador', color: 'text-[#4caf7d]' },
{ key: 'close', label: 'Kết', color: 'text-[#e8a030]' }];


interface TopNavProps {
  slides: typeof SLIDES;
  activeSlide: number;
  onScrollTo: (index: number) => void;
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
}

export default function TopNav({ slides, activeSlide, onScrollTo, navOpen, setNavOpen }: TopNavProps) {
  const currentSection = slides[activeSlide]?.section;
  const progress = (activeSlide + 1) / slides.length * 100;

  const firstIndexOf = (section: string) =>
  slides.findIndex((s) => s.section === section);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0f2318]/90 backdrop-blur-md border-b border-[rgba(76,175,125,0.15)]">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-6">
          <div className="flex items-center gap-3 flex-shrink-0">
            <AppLogo size={32} />
            <span className="font-display font-700 text-[15px] text-[#f0ede6] hidden sm:block tracking-tight">Tri An Green Travel

            </span>
          </div>

          <div className="hidden lg:flex items-center gap-1">
            {SECTIONS.map((sec) => {
              const idx = firstIndexOf(sec.key);
              const isActive = currentSection === sec.key;
              return (
                <button
                  key={`nav-section-${sec.key}`}
                  onClick={() => onScrollTo(idx)}
                  className={`px-4 py-2 rounded-lg text-[13px] font-medium transition-all duration-200 font-body
                    ${isActive ?
                  'bg-[rgba(76,175,125,0.15)] ' + sec.color :
                  'text-[#a0b8a8] hover:text-[#f0ede6] hover:bg-[rgba(255,255,255,0.05)]'}`
                  }>

                  {sec.label}
                </button>);

            })}
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-2">
              <span className="text-[12px] text-[#a0b8a8] font-body tabular-nums">
                {activeSlide + 1} / {slides.length}
              </span>
              <div className="w-24 h-1.5 bg-[rgba(76,175,125,0.15)] rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#4caf7d] to-[#a8d87a] rounded-full transition-all duration-500"
                  style={{ width: `${progress}%` }} />

              </div>
            </div>

            <button
              onClick={() => setNavOpen(!navOpen)}
              className="lg:hidden p-2 rounded-lg text-[#a0b8a8] hover:text-[#f0ede6] hover:bg-[rgba(255,255,255,0.08)] transition-all duration-200"
              aria-label="Toggle navigation">

              {navOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        <div className="h-0.5 bg-[rgba(76,175,125,0.08)]">
          <div
            className="h-full bg-gradient-to-r from-[#4caf7d] to-[#e8a030] transition-all duration-500"
            style={{ width: `${progress}%` }} />

        </div>
      </nav>

      {navOpen &&
      <div className="fixed inset-0 z-40 lg:hidden">
          <div
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          onClick={() => setNavOpen(false)} />

          <div className="absolute top-16 left-0 right-0 bg-[#1a3a2a] border-b border-[rgba(76,175,125,0.2)] max-h-[80vh] overflow-y-auto scrollbar-hide">
            {SECTIONS.map((sec) => {
            const sectionSlides = slides.filter((s) => s.section === sec.key);
            const isActiveSection = currentSection === sec.key;
            return (
              <div key={`mobile-sec-${sec.key}`} className="border-b border-[rgba(76,175,125,0.1)] last:border-0">
                  <div className={`px-6 py-3 text-[11px] font-semibold tracking-widest uppercase font-body ${sec.color} bg-[rgba(0,0,0,0.2)]`}>
                    {sec.label}
                  </div>
                  {sectionSlides.map((slide) => {
                  const globalIdx = slides.findIndex((s) => s.id === slide.id);
                  const isActive = activeSlide === globalIdx;
                  return (
                    <button
                      key={`mobile-slide-${slide.id}`}
                      onClick={() => onScrollTo(globalIdx)}
                      className={`w-full text-left px-8 py-3 text-[14px] font-body transition-all duration-200
                          ${isActive ?
                      'text-[#4caf7d] bg-[rgba(76,175,125,0.1)]' :
                      'text-[#a0b8a8] hover:text-[#f0ede6] hover:bg-[rgba(255,255,255,0.05)]'}`
                      }>

                        <span className="tabular-nums text-[11px] text-[#4caf7d]/50 mr-3">
                          {String(globalIdx + 1).padStart(2, '0')}
                        </span>
                        {slide.label}
                      </button>);

                })}
                </div>);

          })}
          </div>
        </div>
      }
    </>);

}